import React from 'react';
import { t } from '@lingui/core/macro';

import LandingReviewsCarousel from '@rover/react-lib/src/pages/landing/components/LandingReviewsCarousel';
import { useApiLocationBasedReviewsList } from '@rover/rsdk/src/apiClient/latest/api-location-based-reviews-list';

type Props = Pick<React.ComponentProps<typeof LandingReviewsCarousel>, 'my' | 'mt' | 'mb'>;

// An empty `reviews` here means unusable geo or no brand default, not an error — LandingReviewsCarousel already hides itself in that case.
const HomePageReviewsCarousel: React.FC<Props> = (sectionProps) => {
  const { data } = useApiLocationBasedReviewsList();

  return (
    <LandingReviewsCarousel
      {...sectionProps}
      reviews={data?.results ?? []}
      ctaHref="/search/"
      getCardHref={(review) => review.providerProfileUrl}
      cardHrefLabel={t`View sitter profile`}
    />
  );
};

export default HomePageReviewsCarousel;
